import { getApiUrl, isConsolidatedReport } from "./apiHelper";
import { getAppLang } from "./appLanguage";

/**
 * GET readiness recommendations for a report.
 * Server error text is always English, so non-English UI uses fallbackMessage.
 * @param {{ recommFor: string, reportId: string|number, reportData: object, fallbackMessage: string }} options
 */
export async function requestRecommendations({ recommFor, reportId, reportData, fallbackMessage }) {
  const response = await fetch(
    getApiUrl(
      `/api/internal/readiness-score/recommendations/?recomm_for=${recommFor}&report_id=${reportId}&consolidation=${isConsolidatedReport(reportData)}&lang=${getAppLang()}`
    ),
    { method: "GET", redirect: "follow", credentials: "include" }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const serverMessage = errorData.message || errorData.error;
    if (getAppLang() !== "en" && fallbackMessage) {
      throw new Error(fallbackMessage);
    }
    throw new Error(serverMessage || fallbackMessage || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}
